'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import isArticleCoverColor from '@haaretz/s-type-predicates/isArticleCoverColor';
import React from 'react';
const ArticleCoverColorContext = /*#__PURE__*/ React.createContext(undefined);
const ArticleCoverColorSetter = /*#__PURE__*/ React.createContext(undefined);
/**
 * NOTE: It's very important to import getMatchMediaString not from the root of the `@haaretz/l-theme-shared` package,
 * because we don't want to include all the package code into the client bundle.
 */ export function ArticleCoverColorProvider({ children, value: defaultArticleCoverColor }) {
    const [articleCoverColor, setArticleCoverColor] = React.useState(defaultArticleCoverColor);
    const articleCoverColorSetter = React.useCallback((value)=>{
        setArticleCoverColor(isArticleCoverColor(value) ? value : null);
    }, []);
    return /*#__PURE__*/ _jsx(ArticleCoverColorContext, {
        value: articleCoverColor,
        children: /*#__PURE__*/ _jsx(ArticleCoverColorSetter, {
            value: articleCoverColorSetter,
            children: children
        })
    });
}
export default function useArticleCoverColor() {
    const context = React.use(ArticleCoverColorContext);
    if (context === undefined) {
        throw new Error('useArticleCoverColor must be used within a ArticleCoverColorProvider');
    }
    return context;
}
export function useSetArticleCoverColor() {
    const context = React.use(ArticleCoverColorSetter);
    if (context === undefined) {
        throw new Error('useSetArticleCoverColor must be used within a ArticleCoverColorProvider');
    }
    return context;
}
export function useArticleCoverColorAtom() {
    return [
        useArticleCoverColor(),
        useSetArticleCoverColor()
    ];
}

//# sourceMappingURL=articleCoverColorAtom.js.map